export default {
  AllocationMarket: {
    en: 'Welcome to MMPRO NFT Gaming page',
    ru: 'Добро пожаловать на страницу MMPRO NFT',
    ja: '配分市場'
  },
  Subtitle: {
    en: 'Choose wisely, decide quickly',
    ru: 'Коллекция MSPACE',
    ja: ''
  },
  ConnectWalletMessage: {
    en: 'MMPro has started a new activity - "Galactic Run" - Game Bot with tournaments, game, referral program. Stand a chance to win NFTs valued at $1000, $500, $250.',
    ru: 'Здесь вы можете выбрать одну из NFT для участия в розыгрыше FORD MUSTANG и доступа к онлайн-игре',
    ja: 'ウォレットを接続して、METAMASKシェアの割り当てを取得します'
  },
  MetamaskPricesMessage: {
    en: 'Play inside telegram bot: ',
    ru: 'Выбирайте с умом, решайте быстро!',
    ja: ''
  }
}